define("shared/utils/constants/linkinbio-default-style-block", ["exports", "later/utils/is-env", "shared/utils/constants/linkinbio-block-styles", "shared/utils/constants/linkinbio-block-types", "shared/utils/constants/linkinbio-colors", "shared/utils/constants/linkinbio-fonts"], function (_exports, _isEnv, _linkinbioBlockStyles, _linkinbioBlockTypes, _linkinbioColors, _linkinbioFonts) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.SOCIAL_LINK_ICON_COLOR = _exports.PAGE_TEXT_COLOR = _exports.PAGE_FONT_FAMILY = _exports.PAGE_BACKGROUND_TYPE = _exports.PAGE_BACKGROUND_IMAGE_IDENTIFIER = _exports.PAGE_BACKGROUND = _exports.DEFAULT_STYLE_BLOCK_DATA = _exports.BUTTON_TEXT_COLOR = _exports.BUTTON_SHAPE = _exports.BUTTON_OUTLINE = _exports.BUTTON_BOX_SHADOW = _exports.BUTTON_BACKGROUND = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/is-env",0,"shared/utils/constants/linkinbio-block-styles",0,"shared/utils/constants/linkinbio-block-types",0,"shared/utils/constants/linkinbio-colors",0,"shared/utils/constants/linkinbio-fonts"eaimeta@70e063a35619d71f
  const BUTTON_BACKGROUND = _exports.BUTTON_BACKGROUND = _linkinbioColors.TEXT_COLORS.DARK;
  const BUTTON_TEXT_COLOR = _exports.BUTTON_TEXT_COLOR = _linkinbioColors.TEXT_COLORS.DARK;
  const BUTTON_BOX_SHADOW = _exports.BUTTON_BOX_SHADOW = _linkinbioBlockStyles.BOX_SHADOWS[0];
  const BUTTON_OUTLINE = _exports.BUTTON_OUTLINE = _linkinbioBlockStyles.OUTLINES[0];
  const BUTTON_SHAPE = _exports.BUTTON_SHAPE = _linkinbioBlockStyles.SHAPES[0];
  const PAGE_BACKGROUND = _exports.PAGE_BACKGROUND = _linkinbioColors.TEXT_COLORS.LIGHT;
  const PAGE_BACKGROUND_IMAGE_IDENTIFIER = _exports.PAGE_BACKGROUND_IMAGE_IDENTIFIER = '';
  const PAGE_BACKGROUND_TYPE = _exports.PAGE_BACKGROUND_TYPE = 'color';
  const PAGE_FONT_FAMILY = _exports.PAGE_FONT_FAMILY = _linkinbioFonts.FONTS[0];
  const PAGE_TEXT_COLOR = _exports.PAGE_TEXT_COLOR = _linkinbioColors.TEXT_COLORS.DARK;
  const SOCIAL_LINK_ICON_COLOR = _exports.SOCIAL_LINK_ICON_COLOR = _linkinbioColors.TEXT_COLORS.DARK;
  const DEFAULT_STYLE_BLOCK_DATA = _exports.DEFAULT_STYLE_BLOCK_DATA = {
    blockData: {
      enabled: true,
      button_background: BUTTON_BACKGROUND,
      button_text_color: BUTTON_TEXT_COLOR,
      button_box_shadow: BUTTON_BOX_SHADOW.css(),
      button_outline: BUTTON_OUTLINE.css,
      button_shape: BUTTON_SHAPE.css,
      page_background: PAGE_BACKGROUND,
      page_background_image_identifier: PAGE_BACKGROUND_IMAGE_IDENTIFIER,
      page_background_type: PAGE_BACKGROUND_TYPE,
      page_font_family: PAGE_FONT_FAMILY.name,
      page_text_color: PAGE_TEXT_COLOR,
      social_link_icon_color: SOCIAL_LINK_ICON_COLOR
    },
    blockType: _linkinbioBlockTypes.default.Style,
    // Temporary solution to condtionally set the correct theme id
    // staging and prod theme id's aren't in sync
    connectedObjectId: (0, _isEnv.isProduction)() ? '2' : '1',
    connectedObjectType: 'LinkinbioTheme',
    index: null
  };
});